module.exports = __webpack_public_path__ + "img/success.a7cb2f0a.svg";